import { SET_NAVBAR } from './types'

export function setNavbar (navbar) {
  return function (dispatch) {
    dispatch({ type: SET_NAVBAR, navbar })
  }
}



// WEBPACK FOOTER //
// ./src/actions/navbar.js